import React, { useCallback } from 'react';
import useQuestVideoWatchdog from '../../hooks/useQuestVideoWatchdog';
import './OxQuizFlow.css';

export const PICTURE_QUIZ_VERDICT_START_SECONDS = 1.2;

export default function PictureQuizVerdictOverlay({
  videoUrl, onFinished, onAbort,
}) {
  const { videoRef, videoPlaying, isVideoPhase, videoHandlers } = useQuestVideoWatchdog({
    active: true,
    videoUrl,
    onFinished,
    onAbort,
    logLabel: '그림 퀴즈 정답/오답 영상',
  });

  const handleLoadedMetadata = useCallback((event) => {
    const video = event.currentTarget;
    const duration = Number.isFinite(video.duration) ? video.duration : null;
    const startAt = duration == null
      ? PICTURE_QUIZ_VERDICT_START_SECONDS
      : Math.min(PICTURE_QUIZ_VERDICT_START_SECONDS, Math.max(0, duration - 0.05));
    video.currentTime = startAt;
  }, []);

  if (!isVideoPhase) return null;

  return (
    <div className="oxq-verdict-overlay" data-testid="picture-quiz-verdict-overlay">
      <video
        ref={videoRef}
        className={`oxq-verdict-video${videoPlaying ? ' oxq-verdict-video-playing' : ''}`}
        src={videoUrl}
        autoPlay
        playsInline
        preload="auto"
        aria-label="그림 퀴즈 정답 확인 영상"
        data-testid="picture-quiz-verdict-video"
        onLoadedMetadata={handleLoadedMetadata}
        {...videoHandlers}
      />
    </div>
  );
}
